"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBox = void 0;
var react_1 = __importDefault(require("react"));
var LoadingBox_module_scss_1 = __importDefault(require("./LoadingBox.module.scss"));
/**
 * loading animation
 */
var LoadingBox = function () {
    return (react_1.default.createElement("div", { className: LoadingBox_module_scss_1.default.tableLoadingOverlay + " " },
        react_1.default.createElement("div", { className: LoadingBox_module_scss_1.default.loadingBox + " rounded shadow p-4 d-flex m-auto bg-white " },
            react_1.default.createElement("i", { className: "fas fa-2x fa-spin fa-spinner text-cloudLink" }))));
};
exports.LoadingBox = LoadingBox;
exports.default = exports.LoadingBox;
exports.LoadingBox.displayName = 'LoadingBox';
//# sourceMappingURL=LoadingBox.js.map